export const experiences = [
  {
    org: "Craft Software",
    title: "Software Engineer",
    date: "Mar 2023 - present",
    desc: [
      "Developed a full stack solution web applications with React and Spring boot.",
      "Provided exceptional production support for clients by promptly addressing and resolving critical software issues.",
      "Developed a business intelligence dashboard.",
    ],
    lang: ["Java", "PostgreSQL", "React", "Kafka", "AWS"],
    imgSrc: "/logos/unnamedCompany.svg",
  },
  {
    org: "Apple inc (contract)",
    title: "Java Engineer",
    date: "Feb 2022 - March 2023",
    desc: [
      "Geo expansion of services into Europe and South America.",
      "Deliver features with best practices and flexibility for future changes.",
      "Lead migration of Java 11 to Java 17 migration team.",
    ],
    lang: ["Java", "Oracle Databases", "Kafka", "Cloud - Internal"],
    imgSrc: "/logos/apple.svg",
  },
  {
    org: "TWGC",
    title: "Software Engineer",
    date: "Feb 2017 - Oct 2021",
    desc: [
      "Worked with Spring, React, JavaScript, Postgres, Cassandra.",
      "Migrating Legacy applications built with JSP to Spring Framework.",
      "Utilized AWS to deploy and manage cloud infrastructure, enabling scalable and cost-effective solutions for various projects.",
    ],
    lang: ["Java", "Aws", "React", "DynamoDb", "SQL", "Rust", "Java", "Python", "SQL", "Arduino", "C++"],
    imgSrc: "/logos/unnamedCompany.svg",
  },
];
